import { render, staticRenderFns } from "./auditFlowDetail.vue?vue&type=template&id=64ccbc2b&scoped=true&"
import script from "./auditFlowDetail.vue?vue&type=script&lang=ts&"
export * from "./auditFlowDetail.vue?vue&type=script&lang=ts&"
import style0 from "./auditFlowDetail.vue?vue&type=style&index=0&id=64ccbc2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ccbc2b",
  null
  
)

export default component.exports